export default __webpack_public_path__ + "static/media/mars.b64ee159.svg";